<script>
	import Disc from './Disc.svelte'

</script>

<main>
	<Disc />
</main>

<style>

</style>